<span [class]="hostClasses"
      [attr.role]="ariaLabel ? 'img' : null"
      [attr.aria-label]="ariaLabel || null"
      [style.background-color]="color"
      [style.border-color]="borderColor || color"
      [style.color]="textColor">{{ label }}</span>
